module.exports = __webpack_public_path__ + "img/pay_icon.7bd3b9bc.png";